module.exports = __webpack_public_path__ + "Pages-icon.2df5fca00c299cadd3d7.eot";


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/assets/plugins/calendar/fonts/pages-icon/Pages-icon.eot?-u69vo5
// module id = ../../../../../src/assets/plugins/calendar/fonts/pages-icon/Pages-icon.eot?-u69vo5
// module chunks = styles